import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import Password from '../password/Password';

const useStyles = makeStyles((theme) => ({
    label: {
        textAlign: 'center'
    },
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    link: {
        marginTop: theme.spacing(2),
        color: 'var(--color3)'
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function ForgotPassword() {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleOpenClick = () => {
        setOpen(true);
    };

    const handleCloseClick = () => {
        setOpen(false);
    };

    return (
        <div className={classes.label}>
            <Link
                component="button"
                variant="body2"
                onClick={handleOpenClick}
                className={classes.link}
            >
                {i18next.t('password:description.forgot-password')}
            </Link>
            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition} style={{zIndex: '10000'}}>
                <div data-id="headerPassword">
                    <AppBar id="appBarTitle" className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {i18next.t('password:title')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divPassword">
                    <Password />
                </div>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['password'], { wait: true })(ForgotPassword);